import { render, staticRenderFns } from "./protocolText.vue?vue&type=template&id=6aca1d51&scoped=true&"
import script from "./protocolText.vue?vue&type=script&lang=js&"
export * from "./protocolText.vue?vue&type=script&lang=js&"
import style0 from "./protocolText.vue?vue&type=style&index=0&id=6aca1d51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca1d51",
  null
  
)

export default component.exports